import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from "react";
import { toast } from "react-toastify";
import useResumeBusinessSkillsHandlers from "../../../../context/resume/hooks/resume-business-skills-handlers";
import { TranslationContext } from "../../../../context/translations/translations-context";
import useResumeDocumentSection from "../../../../hooks/useResumeDocumentSection";
import StarRating from "../../../assets/StarRating";

export default function CompetenceItem(
    {
        item,
        categoryId,
        parentOrder,
        numberOfItems,
        alreadySelectedItems,
        refCompetences,
    }
) {
    const { translations, displayLanguage } = useContext( TranslationContext );
    // businessSkills contient les catégories et leurs compétences
    const { businessSkills } = useResumeDocumentSection();
    const {
        handleChangeCompetence,
        handleMoveCompetenceDown,
        handleMoveCompetenceUp,
        handleRemoveCompetence,
    } = useResumeBusinessSkillsHandlers( 'businessSkills' );
    const getCompetenceLabel = ( competence ) => (
        competence?.competenceTranslations?.[ displayLanguage ]
        || competence?.competenceTranslations?.fr
        || competence?.competenceTranslations?.en
        || ""
    );

    function handleChange( competence, parentOrder ) {
        if ( !competence.id ) {
            toast.warning( translations.businessSkillsSection.selectCompetenceLabel );
            return;
        }

        const category = businessSkills?.find( category => category?.order === parentOrder );
        const alreadySelected = category?.competences
            ?.some( c => c.id === Number.parseInt( competence.id ) );

        if ( alreadySelected ) {
            toast.warning( translations.businessSkillsSection.competenceAlreadySelectedLabel );
            return;
        }
        handleChangeCompetence( competence, parentOrder );
    }

    function handleCompetenceLevelChange( competence, parentOrder ) {
        // Certains items importés peuvent ne pas avoir d'id : on génère un id de secours
        const effectiveId = competence?.id ?? (
            Number.isInteger( parentOrder ) && Number.isInteger( competence?.order )
                ? parentOrder * 1000 + competence.order + 1
                : null
        );
        if ( !effectiveId ) {
            toast.warning( translations.businessSkillsSection.selectCompetenceLabel );
            return;
        }
        handleChangeCompetence( { ...competence, id: effectiveId }, parentOrder );
    }

    return (
        <div>
            <div className="d-flex align-items-center gap-2"
                 style={ { maxWidth: "100%" } }>
                <div className="input-container">
                    <select
                        autoComplete="off"
                        className="text-white form-select select-input"
                        style={ { width: "210px" } }
                        value={ item.id ?? "" }
                        onChange={
                            ( event ) => {
                                const competenceId = Number.parseInt( event.target.value, 10 );
                                const competence = refCompetences.find( c => c.id === competenceId );
                                if ( !competence ) {
                                    toast.warning( translations.businessSkillsSection.selectCompetenceLabel );
                                    return;
                                }
                                handleChange( {
                                    order: item.order,
                                    id: competence.id,
                                    translations: competence.competenceTranslations,
                                    level: item.level,
                                }, parentOrder );
                            }
                        }
                    >
                        <option value="">
                            { item.translations ? item?.translations?.[ displayLanguage ]
                                : translations.businessSkillsSection.selectCompetenceLabel }
                        </option>
                        {
                            refCompetences
                                .filter( c =>
                                    c.categoryId === categoryId      // keep skill from category
                                    //&& c.id !== item.id              // don't repeat the selected skill
                                    && !alreadySelectedItems.includes( Number.parseInt( c.id ) )
                                )
                                ?.sort( ( a, b ) =>
                                    getCompetenceLabel( a ).localeCompare( getCompetenceLabel( b ), displayLanguage )
                                )
                                ?.map( suggestion => (
                                    <option key={ suggestion?.id }
                                            value={ suggestion?.id }>
                                        { getCompetenceLabel( suggestion ) }
                                    </option>
                                ) )
                        }
                    </select>
                    { item?.translations?.[ displayLanguage ] && (
                        <i className="fas fa-info-circle ms-1" title={ item?.translations?.[ displayLanguage ] }></i>
                    ) }
                </div>
                <StarRating
                    rating={ item.level }
                    onChange={
                        ( rating ) =>
                            handleCompetenceLevelChange( { ...item, level: rating }, parentOrder )
                    }
                />
                <MDBIcon
                    fas
                    icon="arrow-up"
                    role="button"
                    size="1x"
                    onClick={ () => item.order !== 0 && handleMoveCompetenceUp( item, parentOrder ) }
                    style={ { cursor: item.order !== 0 ? "pointer" : "default" } }
                    color={ item.order !== 0 ? "" : "muted" }
                />
                <MDBIcon
                    fas
                    icon="arrow-down"
                    role="button"
                    onClick={ () => item.order !== numberOfItems - 1 && handleMoveCompetenceDown( item, parentOrder ) }
                    style={ { cursor: item.order !== numberOfItems - 1 ? "pointer" : "default" } }
                    color={ item.order !== numberOfItems - 1 ? "" : "muted" }
                />
                <MDBIcon
                    fas
                    icon="trash-alt"
                    role="button"
                    onClick={ () => window.confirm(translations.general.confirmationMessage) && handleRemoveCompetence( item, parentOrder ) }
                    style={ { cursor: 'pointer' } }
                    color='light'
                />
            </div>
        </div>
    );
}
